export default [
  '-v',
  '--version'
] as const
